import { useCallback } from "react"
import { useMutation } from "urql"

import type { DeleteUploadedFileMutation } from "@/graphql/codegen/graphql"
import { DeleteUploadedFileDocument } from "@/graphql/codegen/graphql"

interface FileRemoveHook {
  removeSingleFile: (fileId: string) => Promise<boolean>
  removingInProgress: boolean
}

export const useFilesRemove = (refetchData?: () => void): FileRemoveHook => {
  const [_removeFileResponse, removeFileMutation] = useMutation<DeleteUploadedFileMutation>(DeleteUploadedFileDocument)

  const removeSingleFile = useCallback(
    async (fileId: string): Promise<boolean> => {
      try {
        const response = await removeFileMutation({
          input: {
            fileId,
          },
        })

        if (!response.data) {
          const requestId = response.operation?.key || "N/A"
          console.error(`No data received from file removal - ref: ${requestId}`)
          return false
        }

        const result = response.data.fileUpload.deleteUploadedFile
        if (result.__typename !== "FileUploadedDeleteSuccess") {
          const requestId = response.operation?.key || "N/A"
          console.error(`Failed to remove file - ref: ${requestId} `, result?.error.message)
          return false
        }

        refetchData?.()

        return true
      } catch (error) {
        console.error("Error removing file:", error)
        return false
      }
    },
    [refetchData, removeFileMutation]
  )

  return {
    removeSingleFile,
    removingInProgress: _removeFileResponse.fetching,
  }
}
